/// <amd-module name="Artifacts/Ivy/IvyProtocol" />
/* eslint-disable @typescript-eslint/no-unused-vars */
import { IvyAttributes } from "Artifacts/Ivy/components/IvyPackageAttributes";
import { IvyOverview } from "Artifacts/Ivy/components/IvyPackageOverview";
import { logoContributionId } from "Artifacts/Ivy/components/Logo";
import { IvyModule } from "Artifacts/Ivy/redux/";
import { Protocol } from "Artifacts/Root/Constants";
import { ProtocolService } from "Artifacts/Root/protocols/services/ProtocolService";
import {
  ICommand,
  IProtocol,
  IProtocolOverviewProps,
  IUpstreamingProperties,
} from "Artifacts/Root/protocols/types";
import { IFeed, IPackageVersionIdentity } from "Artifacts/Root/types";
import * as React from "react";
import { IModuleTuple } from "redux-dynamic-modules";
import { IVssPageContext } from "VSS/Platform/Context";

export class IvyProtocol implements IProtocol {
  public readonly id = Protocol.Ivy;
  public readonly name = "Ivy";
  // No public repo, so no status page for ivy
  public readonly statusUrl = undefined;

  public getCommands(
    pageContext: IVssPageContext,
    versions: IPackageVersionIdentity[],
    feed: IFeed,
  ): ICommand[] {
    return [];
  }

  public getLogoContributionId(): string {
    return logoContributionId;
  }

  public getOverviewComponent(): React.ComponentType<IProtocolOverviewProps> {
    return IvyOverview;
  }

  public getOverviewAttributesComponent(): React.ComponentType<IProtocolOverviewProps> {
    return IvyAttributes;
  }

  public getReduxModule(): IModuleTuple {
    return IvyModule;
  }

  getUpstreamOverrideStatus(
    _pageContext: IVssPageContext,
    _packageName: string,
    _feed?: IFeed,
  ): Promise<boolean> {
    throw new Error("Ivy does not support Upstream Override");
  }

  public getUpstreamingProperties(pageContext: IVssPageContext): IUpstreamingProperties {
    return {
      isPublicUpstreamsSupported: false,
      isCustomPublicUpstreamsSupported: false,
      isCollectionUpstreamsSupported: false,
      isAadUpstreamsSupported: false,
    };
  }

  public isProtocolEnabled(pageContext: IVssPageContext): boolean {
    return false;
  }
}

ProtocolService.registerProtocol(new IvyProtocol());
